import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0714 13.6071C10.0714 11.0331 7.98472 8.94643 5.41071 8.94643C2.83667 8.94643 0.75 11.0331 0.75 13.6071M15.25 13.6071C15.25 11.0331 13.1633 8.94643 10.5893 8.94643C9.65808 8.94643 8.79066 9.21955 8.06276 9.69002M4.89286 6.875C5.89388 6.875 6.70536 6.06352 6.70536 5.0625C6.70536 4.06148 5.89388 3.25 4.89286 3.25C3.89184 3.25 3.08036 4.06148 3.08036 5.0625C3.08036 6.06352 3.89184 6.875 4.89286 6.875ZM10.8482 6.875C11.8492 6.875 12.6607 6.06352 12.6607 5.0625C12.6607 4.06148 11.8492 3.25 10.8482 3.25C9.8472 3.25 9.03571 4.06148 9.03571 5.0625C9.03571 6.06352 9.8472 6.875 10.8482 6.875Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgUsers;
